exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".tooltip-container-53wwXTvsmwr{display:inline-flex}.tooltip-tooltip-2k1yTKJTmwr{position:absolute;cursor:default;border-radius:2px;box-shadow:none;color:white;display:inline-block;z-index:1;width:auto;margin:4px 0;max-width:310px}.tooltip-tooltip-2k1yTKJTmwr.tooltip-multiline-612oyOm1mwr{padding:16px;width:310px;white-space:normal}.tooltip-multilineContainer-vWwrgUHHmwr{}.tooltip-icon-FOTL5w3wmwr{cursor:pointer}.tooltip-upward-UkGZCBQamwr{top:auto;bottom:100%}.tooltip-right-2pXFBQqcmwr{left:auto;right:0}.tooltip-title-6iHxXTibmwr{color:white}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"container": "tooltip-container-53wwXTvsmwr",
	"tooltip": "tooltip-tooltip-2k1yTKJTmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["padding-squish-s"] + " " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["ellipsize"] + " " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["paragraph-m"] + " " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["dark-overlay"] + "",
	"multiline": "tooltip-multiline-612oyOm1mwr",
	"multilineContainer": "tooltip-multilineContainer-vWwrgUHHmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["paragraph-s"] + "",
	"icon": "tooltip-icon-FOTL5w3wmwr",
	"upward": "tooltip-upward-UkGZCBQamwr",
	"right": "tooltip-right-2pXFBQqcmwr",
	"title": "tooltip-title-6iHxXTibmwr"
};